import { useMemo } from 'react';
import { MOCK_UNIVERSES, MOCK_WORLD_DETAILS } from '../pages/Chancellery/mockData';
import type { Universe, WorldDetail } from '../types/chancellery';

/**
 * Mock-backed accessor hooks for the Chancellery backoffice UI (SF-103).
 *
 * Reads from pages/Chancellery/mockData.ts today. Exposes the `{ data, loading, error }` shape
 * a real API-backed hook will eventually return with the same signature, so swapping to
 * SF-112–SF-118's real endpoints only touches this file — not component logic or markup.
 */

interface UseUniversesResult {
  data: Universe[] | null;
  loading: boolean;
  error: string | null;
}

interface UseUniverseResult {
  data: Universe | null;
  loading: boolean;
  error: string | null;
}

interface UseWorldResult {
  data: WorldDetail | null;
  loading: boolean;
  error: string | null;
}

export function useUniverses(): UseUniversesResult {
  return { data: MOCK_UNIVERSES, loading: false, error: null };
}

export function useUniverse(universeId: string | undefined): UseUniverseResult {
  const data = useMemo(
    () => MOCK_UNIVERSES.find((u) => u.universeId === universeId) ?? null,
    [universeId]
  );
  return { data, loading: false, error: null };
}

export function useWorld(universeId: string | undefined, worldId: string | undefined): UseWorldResult {
  const data = useMemo(
    () => (universeId && worldId ? MOCK_WORLD_DETAILS[`${universeId}:${worldId}`] ?? null : null),
    [universeId, worldId]
  );
  return { data, loading: false, error: null };
}
